<script>
    import {onMount} from 'svelte';
    import SortableTable from '../SortableTable.svelte';
    import Library from '../../Models/LibraryORM';

    export let assessment_type;

    let selected_section = assessment_type.report_sections.filter(s => s.section_type == "library")[0];

    export let cancelAction = () => {};
    export let saveAction = () => {};
    export let deleteAction = () => {};

    let library_unsub;
    let library_sortFields;
    let library_items;

    function getLibraryData(selected_section) {
        if (!selected_section) return;

        if (library_unsub) {
            // unsubscribe from previous library
            library_unsub();
            library_unsub = undefined;
        }

        let library_model = new Library(selected_section.library_type);

        library_unsub = library_model.store.subscribe((lib) => {
            if (!lib) return;

            library_sortFields = [
                {
                    field: "name",
                    label: "Name"
                },
                ...lib.fields.fields.map(f => {
                return {
                    field: f.details.name,
                    label: f.details.name
                }
            })];

            library_items = lib.items.items;
        })
    }

    onMount(() => {
        return () => {
            if (library_unsub) {
                library_unsub()
            }
        }
    })

    $: getLibraryData(selected_section);
</script>

<div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-fullwidth">
        <header class="modal-card-head">
            <p class="modal-card-title">Create Mapping</p>
            <button class="delete" aria-label="close" on:click={cancelAction}></button>
        </header>
        <section class="modal-card-body">

            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <span class="label">Library Section</span>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control select is-fullwidth">
                            <select bind:value={selected_section}>
                                {#each assessment_type.report_sections as section}
                                    {#if section.section_type == "library"}
                                        <option value={section}>{section.section_name}</option>
                                    {/if}
                                {/each}
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            {#if selected_section}
                <SortableTable sortFields={library_sortFields} tableData={library_items} ORM="true">
                    <div slot="rowActions" let:row={item}>
                        <div class="button is-success" on:click={() => saveAction({
                            type: "library_item",
                            section_id: selected_section.section_id,
                            id: item.details._id
                        })}>
                            Select Item
                        </div>
                    </div>
                </SortableTable>
            {/if}
        </section>
        <footer class="modal-card-foot has-text-right">
            <button class="button is-pulled-right" on:click={cancelAction}>Close</button>
        </footer>
    </div>
</div>


<style>
    .field-label {
        flex-grow: 0;
        flex-basis: content;
    }
</style>